export const articles = [
  {
    category: "Coffee",
    title:
      "49 Gifts for Coffee Lovers, Espresso Drinkers, and Cold Brew Devotees",
    URL: "https://www.epicurious.com/expert-advice/coffee-gift-ideas-article",
    imgURL:
      "https://assets.epicurious.com/photos/5c916d88f71d3173842518fa/16:9/w_350/Best-Low-Acid-Coffee-Hero-Alt-13032019.jpg",
  },
  {
    category: "Coffee",
    title: "The 45 Best Kitchen and Cooking Gifts for 2021",
    URL: "https://www.epicurious.com/shopping/the-best-kitchen-and-cooking-gifts-2021-article",
    imgURL:
      "https://assets.epicurious.com/photos/6193e764a53abd8645d77b62/16:9/w_350/GiftGuide2021_HERO_111021_1597_VOG_final.jpg",
  },
  {
    category: "Tea",
    title: "The 27 Best Gifts for Tea Lovers",
    URL: "https://www.epicurious.com/expert-advice/tea-gifts-article",
    imgURL:
      "https://assets.epicurious.com/photos/5c916992e9947c19f111ec96/16:9/w_350/Clotted-Cream-Is-the-Best-13032019.jpg",
  },
  {
    category: "Tea",
    title: "The 45 Best Kitchen and Cooking Gifts for 2021",
    URL: "https://www.epicurious.com/shopping/the-best-kitchen-and-cooking-gifts-2021-article",
    imgURL:
      "https://assets.epicurious.com/photos/6193e764a53abd8645d77b62/16:9/w_350/GiftGuide2021_HERO_111021_1597_VOG_final.jpg",
  },
  {
    category: "Entertaining",
    title: "27 Decor Gifts for Everyone On Your List",
    URL: "https://www.epicurious.com/expert-advice/27-decor-gifts-for-everyone-on-your-list-article",
    imgURL:
      "https://assets.epicurious.com/photos/5fb55670b386ee79cb6894a5/16:9/w_350/Tabletop_GiftGuide_111120_5048_V1_final.jpg",
  },
  {
    category: "Entertaining",
    title: "The 45 Best Kitchen and Cooking Gifts for 2021",
    URL: "https://www.epicurious.com/shopping/the-best-kitchen-and-cooking-gifts-2021-article",
    imgURL:
      "https://assets.epicurious.com/photos/6193e764a53abd8645d77b62/16:9/w_350/GiftGuide2021_HERO_111021_1597_VOG_final.jpg",
  },
  {
    category: "Camping",
    title: "The Best Camping Cooking Gear for More Than Just S’mores",
    URL: "https://www.epicurious.com/expert-advice/the-best-camping-cooking-gear-for-more-than-just-smores-article",
    imgURL:
      "https://assets.epicurious.com/photos/60d2207852a39426294f45af/16:9/w_350/CampingCookingGear_HERO_061621_1652_V1_final.jpg",
  },
  {
    category: "Camping",
    title: "The 45 Best Kitchen and Cooking Gifts for 2021",
    URL: "https://www.epicurious.com/shopping/the-best-kitchen-and-cooking-gifts-2021-article",
    imgURL:
      "https://assets.epicurious.com/photos/6193e764a53abd8645d77b62/16:9/w_350/GiftGuide2021_HERO_111021_1597_VOG_final.jpg",
  },
  {
    category: "Baking",
    title: "The Best Gifts for Bakers, Cake Decorating Pros, and Pie Lovers",
    URL: "https://www.epicurious.com/holidays-events/baking-gift-guide-article",
    imgURL:
      "https://assets.epicurious.com/photos/5c87e2bab8df0b1a61bf751d/16:9/w_350/Cake-Turntable-Hero-05032019.jpg",
  },
  {
    category: "Baking",
    title: "The 45 Best Kitchen and Cooking Gifts for 2021",
    URL: "https://www.epicurious.com/shopping/the-best-kitchen-and-cooking-gifts-2021-article",
    imgURL:
      "https://assets.epicurious.com/photos/6193e764a53abd8645d77b62/16:9/w_350/GiftGuide2021_HERO_111021_1597_VOG_final.jpg",
  },
  {
    category: "Wine",
    title:
      "33 Gifts for Wine Lovers That Aren't Cutesy Charms for Their Glasses",
    URL: "https://www.epicurious.com/expert-advice/best-gifts-for-wine-lovers-article",
    imgURL:
      "https://assets.epicurious.com/photos/5d8122ce5fe8220008377ab0/16:9/w_350/WineGlasses_HERO_091119_5151.jpg",
  },
  {
    category: "Wine",
    title: "The 45 Best Kitchen and Cooking Gifts for 2021",
    URL: "https://www.epicurious.com/shopping/the-best-kitchen-and-cooking-gifts-2021-article",
    imgURL:
      "https://assets.epicurious.com/photos/6193e764a53abd8645d77b62/16:9/w_350/GiftGuide2021_HERO_111021_1597_VOG_final.jpg",
  },
  {
    category: "Cocktail",
    title: "The Best Gifts for Whiskey Lovers",
    URL: "https://www.epicurious.com/shopping/the-best-gifts-for-whiskey-lovers-article",
    imgURL:
      "https://assets.epicurious.com/photos/5e41d5ef1d48a1000814dbb7/16:9/w_350/Manhattan_HERO_020520_472.jpg",
  },
  {
    category: "Cocktail",
    title: "The 45 Best Kitchen and Cooking Gifts for 2021",
    URL: "https://www.epicurious.com/shopping/the-best-kitchen-and-cooking-gifts-2021-article",
    imgURL:
      "https://assets.epicurious.com/photos/6193e764a53abd8645d77b62/16:9/w_350/GiftGuide2021_HERO_111021_1597_VOG_final.jpg",
  },
  {
    category: "Cooking",
    title: "The 45 Best Kitchen and Cooking Gifts for 2021",
    URL: "https://www.epicurious.com/shopping/the-best-kitchen-and-cooking-gifts-2021-article",
    imgURL:
      "https://assets.epicurious.com/photos/6193e764a53abd8645d77b62/16:9/w_350/GiftGuide2021_HERO_111021_1597_VOG_final.jpg",
  },
]
